<template>
    <v-container>      
        <!--  color="#337ab7" -->  
        <v-app-bar app color="primary" dark dense >
            <v-app-bar-nav-icon @click="MostrarMenuLateral=true"></v-app-bar-nav-icon>
            <v-toolbar-title class="pl-0">
                <v-img :src="require('../assets/IsoLogo_Area.png')" contain width="30" class=""></v-img>
            </v-toolbar-title>
            {{tituloPrincipalAMostrar}}
            <v-spacer></v-spacer>
            v.{{getNumeroVersion()}}
        </v-app-bar>    
        
        <v-navigation-drawer v-model="MostrarMenuLateral" absolute temporary>
            <v-list-item>
                <v-list-item-avatar><v-img :src="nombreLogo"></v-img></v-list-item-avatar>
                <v-list-item-content><v-list-item-title>Area 54</v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list dense>
                <v-divider v-if="!estaLoggeado"></v-divider>
                <router-link to="/Login" v-if="!estaLoggeado">
                    <v-list-item link>
                        <v-icon class="mx-3" color="home">mdi-login</v-icon>
                        <v-list-item-content>
                            <v-list-item-title>Iniciar sesión</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <v-divider v-if="estaLoggeado"></v-divider>
                <router-link to="/VerRutaActual" v-if="estaLoggeado">
                    <v-list-item link>
                        <v-icon class="mx-3" color="green">mdi-map-marker-path</v-icon>
                        <v-list-item-content>
                            <v-list-item-title>Ruta</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <v-divider v-if="estaLoggeado"></v-divider>
                <router-link to="/Configurar" v-if="estaLoggeado">
                    <v-list-item link>
                        <v-icon class="mx-3" color="green">mdi-account-cog-outline</v-icon>
                        <v-list-item-content>
                            <v-list-item-title>Configurar</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <v-divider v-if="estaLoggeado"></v-divider>

                <v-footer absolute class="mb-10">
                    <router-link to="/Logout"  v-if="estaLoggeado">
                        <v-list-item link>
                            <v-icon class="mx-3" color="cerrarSesion">mdi-logout</v-icon>
                            <v-list-item-content>
                                <v-list-item-title>Cerrar la sesión</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                </v-footer>
            </v-list>
        </v-navigation-drawer>
    </v-container>
</template>

<style scoped>
    a {
        text-decoration: none;
    }
</style>

<script>

import store from '../store'

export default {
    name: 'MenuPrincipal',
    props: {
        tituloPrincipal: String
    },
    methods: {
        getNumeroVersion() {
            var pjson = require('../../package.json')
            return pjson.version
        }
    },
    computed: {
        estaLoggeado() {
            return store.state.choferes.choferActual.loggeado
        },
        nombreChofer() {
            return store.state.choferes.choferActual.nombre
        },
        numeroChofer() {
            return store.state.choferes.choferActual.numero
        },
        tituloPrincipalAMostrar() {
            //return this.tituloPrincipal===null ? process.env.VUE_APP_Nombre : this.tituloPrincipal
            if (store.state.choferes.choferActual.loggeado) {
                return store.state.choferes.choferActual.numero+" - "+store.state.choferes.choferActual.nombre
            } else {
                return "No identificado"
            }
        }
    },
    data() {
        return {
            MostrarMenuLateral: false,
            nombreLogo:require("../assets/IsoLogo_Area.png"),
            NombreQuienSoy: process.env.VUE_APP_Nombre
        }
    }
}
</script>